import styled from '@emotion/styled';
import { BROWN, PRIMARY } from '../../../../shared/colors';

const Container = styled.div`
  > .top {
    background-color: ${PRIMARY};
    padding: 5px;
    font-family: Poppins-R;
    border-radius: 5px;
    text-transform: uppercase;
  }

  > .content {
    padding: 3px;
    overflow-x: hidden;
    overflow-y: auto;
    max-height: calc(100vh - 545px);
    font-family: Poppins-R;
    font-size: 10.5px;

    p {
      margin: 0px;
      cursor: pointer;

      &:hover {
        background-color: ${BROWN};
        border-radius: 5px;
      }
    }

    &::-webkit-scrollbar {
      width: 0.5vw;
    }

    &::-webkit-scrollbar-thumb {
      background-image: linear-gradient(to bottom, #eceff1, #eceff1);
      border-radius: 10px;
    }
  }
`;

export const News = () => {
  return (
    <Container>
      <div className='top' style={{ color: 'orange', paddingLeft: 10 }}>Actualités</div>
      <div className='content'>
        <p style={{ color: 'gray' }}>HEURE-SOURCE-SYMBOL-TITRE</p>

        <p>
          06/26 23:14 BZFR 12 titres de consommation discrétionnaire en
          mouvement lorsque
        </p>
        <p>07/26 23:14 USIG 12 Volume spike up</p>
        <p>
          06/26 23:14 LTHM 12 titres informatique en mouvement lors de la
          session d'apprentissage discrétionnaire
        </p>
        <p>
          06/26 23:14 BZFR 12 titres de consommation discrétionnaire en
          mouvement lorsque
        </p>
        <p>
          06/26 23:14 BZFR 12 titres de service de communication en mouvement
          discrétionnaire en mouvement lorsque
        </p>
        <p>
          06/26 23:14 BZFR 12 titres de consommation discrétionnaire en
          mouvement lorsque
        </p>
      </div>
    </Container>
  );
};
